import Controller from '@ember/controller';
import type { ModelType } from 'codecrafters-frontend/routes/team';

export default class TeamController extends Controller {
  declare model: ModelType;
}
